export function isStreamingConfigEnabled(config = {}) {
    return Boolean(config?.stream?.enabled)
}
